import styled from 'styled-components';

import MaterialIcon from '@/components/atom/MaterialIcon';
import theme from '@/styles/theme';

const QnaWriteVerified = () => {
  return (
    <QuickAnswerWriteImagesFieldWrapper>
      <QuestionImageInformation>
        <ImageInformationTitle>
          <MaterialIcon name={'verified_user'} size={16} color={theme.color.blue700} filled />
          안심하세요!
        </ImageInformationTitle>
        <ImageInformationList>
          <ImageInformationListItem>
            개인정보 보호를 위해 질문에 개인정보를 입력하지 않도록 주의해 주세요.
          </ImageInformationListItem>
        </ImageInformationList>
      </QuestionImageInformation>
    </QuickAnswerWriteImagesFieldWrapper>
  );
};

export default QnaWriteVerified;

const QuickAnswerWriteImagesFieldWrapper = styled.div`
  padding: 40px 0;
`;

const QuestionImageInformation = styled.div`
  padding: 16px;
  border-radius: 8px;
  background: ${({ theme }) => theme.color.blue100};
`;

const ImageInformationTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;

  ${({ theme }) => `
    ${theme.typography.UI14SB};
    color: ${theme.color.blue500};
  `};
  
`;

const ImageInformationList = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
`;

const ImageInformationListItem = styled.li`
  position: relative;
  margin-left: 4px;
  padding-left: 12px;
  margin-bottom: 4px;

  &:last-child {
    margin-bottom: 0;
  }

  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 7px;
    width: 3.5px;
    height: 3.5px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.color.gray400};
  }

  ${({ theme }) => `
    ${theme.typography.UI13R};
    color: ${theme.color.gray500};
    line-height: 18px;
  `};
`;
